import FaqPage from '@/components/feature/FaqPage';

export default function SmQ1Page() {
  return (
    <FaqPage
      category="Subscription Management"
      categoryPath="/"
      icon="ri-close-circle-line"
      title="Cancelling my subscription"
      intro="Learn how to cancel your subscription and understand the cancellation process, including what happens to your access and any pending charges."
      sections={[
        {
          heading: 'How do I cancel my subscription?',
          content: [
            'To cancel your subscription, log in to your account and navigate to Account Settings > Subscription. From there, click "Cancel Subscription" and follow the on-screen prompts.',
            'You will receive a confirmation email once your cancellation has been processed. Please keep this email for your records.',
          ],
        },
        {
          heading: 'When does my access end?',
          content: [
            'Your access to the service will continue until the end of your current billing period. For example, if you cancel on the 10th of the month and your billing cycle ends on the 25th, you will retain access until the 25th.',
            'After the billing period ends, your account will be downgraded and you will no longer be charged.',
          ],
        },
        {
          heading: 'Will I receive a refund when I cancel?',
          content: [
            'Cancellations are not eligible for a prorated refund for the current billing period. However, you will not be charged for any future billing cycles.',
            'If you believe you have been charged in error, please contact our support team or submit a dispute resolution request.',
          ],
        },
        {
          heading: 'Can I reactivate my subscription after cancelling?',
          content: [
            'Yes, you can reactivate your subscription at any time by logging back into your account and selecting a plan. Your previous settings and data may still be available depending on how long ago you cancelled.',
          ],
        },
      ]}
    />
  );
}
